
import cmsBlock from '~/mixins/cmsBlock'
import lazyBgImage from '~/mixins/lazyBgImage'

export default {
  name: 'CmsMediclub3Cards',
  mixins: [cmsBlock, lazyBgImage],

  data () {
    return {
      fallbackContent: {
        title: 'Comprehensive thematic areas',
        subtitle: 'only for MediClub Members',
        mediCard: {
          title: 'MediClub',
          ico: '/mc/v3/block4/ico/prevention.svg',
          img: '/mc/v3/block4/bg/MediClub.png',
          to: '/mediclub',
        },

        cards: [
          {
            title: 'Prevention',
            ico: '/mc/v3/block4/ico/prevention.svg',
            img: '/mc/v3/block4/bg/Prevention.png',
            to: '/url',
          },
          {
            title: 'Physical Activity',
            ico: '/mc/v3/block4/ico/physicalActivity.svg',
            img: '/mc/v3/block4/bg/Physical.png',
            to: '/mediclub/aktywnosc-fizyczna',
          },
          {
            title: 'Treatment',
            ico: '/mc/v3/block4/ico/treatment.svg',
            img: '/mc/v3/block4/bg/Treatment.png',
            to: '/url',
          },
          {
            title: 'Healthy Nutrition',
            ico: '/mc/v3/block4/ico/healthyNutrition.svg',
            img: '/mc/v3/block4/bg/Nutrition.png',
            to: '/url',
          },
          {
            title: 'Mental Health',
            ico: '/mc/v3/block4/ico/mentalHealth.svg',
            img: '/mc/v3/block4/bg/Mental.png',
            to: '/url',
          },
          {
            title: 'Image',
            ico: '/mc/v3/block4/ico/Image.svg',
            img: '/mc/v3/block4/bg/Image.png',
            to: '/url',
          },
          {
            title: 'Healthy Maternity',
            ico: '/mc/v3/block4/ico/healthyMaternity.svg',
            img: '/mc/v3/block4/bg/Maternity.png',
            to: '/url',
          },
          {
            title: 'For Kids',
            ico: '/mc/v3/block4/ico/for-kids.svg',
            img: '/mc/v3/block4/bg/Kids.png',
            to: '/url',
          },
        ],
      },
    }
  },
}
